<template>
  <v-container>
    <v-layout
      style="width: 100%"
      :class="[$vuetify.breakpoint.xsOnly ?  'd-block' : 'd-inline-flex']"
    >
      <v-flex
        style="display: flex"
        :class="{'mb-3 text-xs-center justify-center': $vuetify.breakpoint.xsOnly}"
        pt-1
      >
        <v-icon class="mr-2" :color="workRequest.CanPerform ? 'green': 'red'">control_camera</v-icon>
        <span class="pt-1">{{ workRequest.StageName }}</span>
      </v-flex>
      <v-flex
        :class="[$vuetify.breakpoint.xsOnly ?  'd-block' : 'd-inline-flex']"
        style="max-width: 600px"
        wrap
      >
        <!-- кнопки возврата -->
        <v-dialog
          v-if="workRequest.CanPerform && (workRequest.StageCode == 'F' || workRequest.StageCode == 'O')"
          v-model="closeDialog"
          max-width="290"
          lazy
          style="width: 100%"
        >
          <v-btn
            slot="activator"
            :loading="loading"
            block
            color="red"
            dark
            :class="$vuetify.breakpoint.smAndUp ? '' : 'mt-1'"
          >
            <v-icon>chevron_left</v-icon>
            {{ $t('equipment.workRequests.backToPerformer') }}
          </v-btn>
          <v-card>
            <v-card-title class="headline">{{ $t('equipment.workRequests.giveReason') }}</v-card-title>
            <v-card-text>
              <v-text-field
                v-model="comment"
                @keyup.enter="closeDialog = false; modifyWorkRequests({workRequestId : workRequest.IdApplication, action: 'return', additionalParams: comment}); comment = ''"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                flat
                block
                @click="closeDialog = false; modifyWorkRequests({workRequestId : workRequest.IdApplication, action: 'return', additionalParams: comment}); comment = ''"
              >{{ $t('yes') }}</v-btn>
              <v-btn color="green darken-1" flat @click="closeDialog = false;">{{ $t('no') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog
          v-if="workRequest.CanPerform && workRequest.StageCode == 'R'"
          v-model="toDeclarerDialog"
          max-width="290"
          style="width: 100%"
          color="red"
          lazy
        >
          <v-btn
            slot="activator"
            :loading="loading"
            block
            dark
            color="red"
            :class="$vuetify.breakpoint.smAndUp ? '' : 'mt-1'"
          >
            <v-icon>chevron_left</v-icon>
            {{ $t('equipment.workRequests.returnToDeclarer') }}
          </v-btn>
          <v-card>
            <v-card-title class="headline">{{ $t('equipment.workRequests.giveReason') }}</v-card-title>
            <v-card-text>
              <v-text-field
                v-model="comment"
                @keyup.enter="closeDialog = false; modifyWorkRequests({workRequestId : workRequest.IdApplication, action: 'return', additionalParams: comment}); comment = ''"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                flat
                @click="toDeclarerDialog = false; modifyWorkRequests({workRequestId : workRequest.IdApplication, action: 'return', additionalParams: comment}); comment = ''"
              >{{ $t('yes') }}</v-btn>
              <v-btn color="green darken-1" flat @click="toDeclarerDialog = false; ">{{ $t('no') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        <!-- /кнопки возврата -->
        <!-- кнопки вперед -->
        <v-btn
          block
          dark
          color="green darken-1"
          v-if="workRequest.CanPerform && workRequest.StageCode == 'R'"
          :loading="loading"
          @click="workRequestStage({workRequestId : workRequest.IdApplication, action: 'take', additionalParams: ''})"
        >
          {{ $t('equipment.workRequests.beginWork') }}
          <v-icon>chevron_right</v-icon>
        </v-btn>

        <v-btn
          block
          dark
          color="green darken-1"
          v-if="workRequest.CanPerform && (workRequest.StageCode == 'F' || workRequest.StageCode == 'O')"
          :loading="loading"
          @click="ratingDialog = true"
        >
          {{ $t('equipment.workRequests.approve') }}
          <v-icon>chevron_right</v-icon>
        </v-btn>
        <!-- в одну кнопку спрятано -->
        <v-btn
          block
          dark
          color="green darken-1"
          v-if="workRequest.CanPerform && (workRequest.StageCode == 'E' || workRequest.StageCode == 'C')"
          :loading="loading"
          @click="workRequestStage({workRequestId : workRequest.IdApplication, action: 'confirm', additionalParams: ''})"
        >
          {{ workRequest.StageCode == 'E' ? $t('equipment.workRequests.done') : $t('equipment.workRequests.toPerformer') }}
          <v-icon>chevron_right</v-icon>
        </v-btn>

        <!-- <v-btn
          block
          dark
          color="green darken-1"
          v-if="workRequest.CanPerform && (workRequest.StageCode == 'E')"
          :loading="loading"
          @click="workRequestStage({workRequestId : workRequest.IdApplication, action: 'confirm', additionalParams: ''})"
        >
          {{ $t('equipment.workRequests.done') }}
          <v-icon>chevron_right</v-icon>
        </v-btn>

        <v-btn
          block
          dark
          color="green darken-1"
          v-if="workRequest.CanPerform && (workRequest.StageCode == 'C')"
          :loading="loading"
          @click="workRequestStage({workRequestId : workRequest.IdApplication, action: 'confirm', additionalParams: ''})"
        >
          {{ $t('equipment.workRequests.toPerformer') }}
          <v-icon>chevron_right</v-icon>
        </v-btn>-->
        <!-- /кнопки вперед -->
        <!-- кнопка отмены -->
        <v-dialog
          v-if="workRequest.CanPerform && (workRequest.StageCode == 'R' || workRequest.StageCode == 'E')"
          v-model="cancelDialog"
          max-width="290"
          lazy
        >
          <v-btn
            :block="$vuetify.breakpoint.smAndUp ? '' : 'block'"
            dark
            :class="$vuetify.breakpoint.smAndUp ? '' : 'mt-1'"
            color="red darken-2"
            slot="activator"
            :style="[$vuetify.breakpoint.smAndUp ? 'width: 250px' : 'width: 100%;']"
            :loading="loading"
          >{{ $t('cancelFull') }}</v-btn>
          <v-card>
            <v-card-title class="headline">{{ $t('equipment.workRequests.giveReason') }}</v-card-title>
            <v-card-text>
              <v-text-field
                @keyip.enter="closeDialog = false; modifyWorkRequests({workRequestId : workRequest.IdApplication, action: 'return', additionalParams: comment}); comment = ''"
                v-model="comment"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                flat
                @click="cancelDialog = false; modifyWorkRequests({workRequestId : workRequest.IdApplication, action: 'cancel', additionalParams: comment})"
              >{{ $t('yes') }}</v-btn>
              <v-btn color="green darken-1" flat block @click="cancelDialog = false;">{{ $t('no') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- /кнопка отмены -->
        <!-- кнопка назначить/изменить исполнителя -->
        <v-flex
          :class="$vuetify.breakpoint.smAndUp ? 'text-xs-right' : 'mt-1 align-center'"
          v-if="workRequest.CanAssign && workRequest.CanPerform && (workRequest.StageCode == 'R' || workRequest.StageCode == 'E')"
        >
          <v-menu 
            v-model="menu"
            :close-on-content-click="false"
            lazy
            left
            offset-x
            nudge-left="100"
            full-width>
            <template slot="activator">
              <v-flex ml-3>
                <v-btn color="orange" dark icon :loading="loading">
                  <v-icon>{{workRequest.StageCode == 'R' ? 'person_add' : 'people'}}</v-icon>
                </v-btn>
              </v-flex>
            </template>
            <v-card>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in responsibleList"
                  :key="index"
                  @click="menu=false; if(item.Code) modifyWorkRequests({workRequestId : workRequest.IdApplication, action: workRequest.StageCode == 'R' ?'setperformer':'changeperformer', additionalParams: item.Code}); updateAdditionalInformationComp()"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.Name }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card>
          </v-menu>
        </v-flex>
      </v-flex>
      <!-- кнопка назначить/изменить исполнителя -->
    </v-layout>
    <v-dialog v-model="ratingDialog" max-width="290" lazy>
      <v-card>
        <v-card-title
          primary-title
          class="headline green darken-1"
          style="color: white"
        >№ {{workRequest.IdApplication}}
        </v-card-title>
        <v-card-text>
          <!-- <v-img
            src="https://it.it-enterprise.com/ws/GetFile.ashx?file=30a0926fe40e23c541fa457c1410ddb2"
          ></v-img>-->
          <v-flex v-if="workRequest.ResponsibleName" text-xs-center pb-2 title>
            <v-icon color="orange">directions_run</v-icon>
            <span>{{ workRequest.ResponsibleName }}</span>
          </v-flex>

          <div class="text-xs-center">
            <v-rating
              v-model="rating"
              background-color="black"
              color="yellow accent-4"
              half-icon="fas fa-star-half-alt"
              full-icon="fas fa-star"
              empty-icon="far fa-star"
              half-increments
              hover
            ></v-rating>
          </div>
          <v-text-field v-model="comment" :label="$t('enterComment')" color="blue"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn
            :disabled="!buttonController"
            color="green darken-1"
            flat="flat"
            center
            @click="ratingDialog = false; modifyWorkRequests({workRequestId : workRequest.IdApplication, action: 'confirm', additionalParams: JSON.stringify({evaluation: rating, comment})}); comment = ''; rating = null"
          >{{ buttonController ? $t('equipment.workRequests.approve') : $t('equipment.workRequests.ratingRequired')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    workRequest: Object,
    validator: function(value) {
      return ['IdApplication', 'StageCode'].indexOf(value) !== -1
    }
  },
  methods: {
    ...mapActions([
      'workRequestStage',
      'updatePerformers',
      'clearWorkRequestStageMessage',
      'workRequestStage',
      'updateComments',
      'modifyWorkRequests',
      'updateAdditionalInformation'
    ]),
    updateAdditionalInformationComp() {
      this.updateAdditionalInformation({ workRequestId: this.workRequest.IdApplication});
    }
    
  },
  data() {
    return {
      buttonController: false,
      rating: null,
      cancelDialog: false,
      toDeclarerDialog: false,
      ratingDialog: false,
      commentDialog: false,
      dateMenu: false,
      endDateMenu: false,
      dialogFinish: false,
      closeDialog: false,
      confirmOrder: false,
      additionalDialog: false,
      comment: "",
      menu: false
    };
  },
  computed: {
    responsibleList() {
      return this.$store.state.workRequests.responsibleList;
    },
    loading() {
      return this.$store.state.base.loading
    },
    workRequestStageMessage: {
      get() {
        return this.$store.state.workRequests.workRequestStageMessage
      },
      set() {
        this.clearWorkRequestStageMessage()
      }
    },
    comments() {
      return this.$store.state.workRequests.comments;
    }
  },
  watch: {
    rating() {
      this.rating != null ? this.buttonController = true : this.buttonController = false
    },
    menu() {
      if (this.menu) {
        this.updatePerformers({
          workRequestId: this.workRequest.IdApplication
        })
      }
    },
  }
};
</script>

